module.exports = __webpack_public_path__ + "img/logo.563cbf29.jpg";